// Odliczanie do końca promocji: stała data, bez restartu; po końcu pasek znika
(function () {
  document.querySelectorAll('[data-cz-countdown]').forEach(function (bar) {
    var end = new Date(bar.dataset.czCountdown).getTime();
    if (isNaN(end)) return;
    var out = { d: bar.querySelector('[data-u="d"]'), h: bar.querySelector('[data-u="h"]'), m: bar.querySelector('[data-u="m"]'), s: bar.querySelector('[data-u="s"]') };
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { bar.hidden = true; clearInterval(t); return; }
      out.d.textContent = Math.floor(left / 86400);
      out.h.textContent = pad(Math.floor(left % 86400 / 3600));
      out.m.textContent = pad(Math.floor(left % 3600 / 60));
      out.s.textContent = pad(left % 60);
    };
    var t = setInterval(tick, 1000); tick();
  });
})();

// Padający śnieg: lekki canvas, mniej płatków na telefonie, stop w ukrytej karcie
(function () {
  var cv = document.querySelector('[data-cz-snow]');
  if (!cv || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ctx = cv.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2), W, H, flakes = [];
  var resize = function () { W = cv.clientWidth; H = cv.clientHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
  resize(); window.addEventListener('resize', resize);
  var count = W < 750 ? 45 : 90;
  var make = function (top) { return { x: Math.random() * W, y: top ? -10 : Math.random() * H, r: 1.2 + Math.random() * 2.6, vy: .4 + Math.random() * .9, vx: -.3 + Math.random() * .6, ph: Math.random() * 6.28, a: .55 + Math.random() * .4 }; };
  for (var i = 0; i < count; i++) flakes.push(make(false));
  var run = true;
  document.addEventListener('visibilitychange', function () { run = !document.hidden; if (run) requestAnimationFrame(draw); });
  function draw() {
    if (!run) return;
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < flakes.length; i++) {
      var f = flakes[i];
      f.ph += .015; f.y += f.vy; f.x += f.vx + Math.sin(f.ph) * .3;
      if (f.y > H + 10) flakes[i] = f = make(true);
      ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.283);
      ctx.fillStyle = 'rgba(255,255,255,' + f.a + ')';
      ctx.shadowColor = 'rgba(90,110,120,.35)'; ctx.shadowBlur = 2;
      ctx.fill();
    }
    requestAnimationFrame(draw);
  }
  requestAnimationFrame(draw);
})();
